<template>
  <validation-observer tag="div" ref="form">
    <div class="row">
      <validation-provider class="col-6" vid="name" :name="lodash.startCase($t('users.name'))" :rules="{ required: true }" v-slot="{ valid, errors }">
        <b-form-group
            class="row mb-3 asterisk-after-text"
            label-cols-md="12"
            :label="lodash.startCase($t('users.name'))"
            label-for="name"
            :state="errors[0] ? false : (valid ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <b-form-input
              for="name"
              type="text"
              autocomplete="false"
              required
              :state="errors[0] ? false : (valid ? true : null)"
              v-model="model.name"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
      <validation-provider ref="emailProvider" class="col-6" vid="email" :name="lodash.startCase($t('users.email'))" :rules="{ required: true, email: true, jala_user_exists: !model.id }" v-slot="{ valid, errors }">
        <b-form-group
            class="row mb-3 asterisk-after-text"
            label-cols-md="12"
            :label="lodash.startCase($t('users.email'))"
            label-for="email"
            :state="errors[0] ? false : (valid ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <b-form-input
              for="email"
              name="email"
              type="email"
              required
              :readonly="model.id"
              :state="errors[0] ? false : (valid ? true : null)"
              v-model="model.email"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
    </div>
    <div class="row">
      <validation-provider class="col-6" vid="phone" :name="lodash.startCase($t('users.phone'))" :rules="{ required: true, phone: true }" v-slot="{ valid, errors }">
        <b-form-group
            class="row mb-3 asterisk-after-text"
            label-cols-md="12"
            :label="lodash.startCase($t('users.phone'))"
            label-for="phone"
            :state="errors[0] ? false : (valid ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <b-form-input
              for="phone"
              name="phone"
              type="tel"
              required
              :state="errors[0] ? false : (valid ? true : null)"
              v-model="model.phone"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
      <validation-provider class="col-6" vid="position" :name="lodash.startCase($t('users.position'))" :rules="{ required: true }" v-slot="{ valid, errors }">
        <b-form-group
            class="row mb-3 asterisk-after-text"
            label-cols-md="12"
            :label="lodash.startCase($t('users.position'))"
            label-for="position"
            :state="errors[0] ? false : (valid ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <b-form-input
              for="position"
              name="position"
              type="text"
              required
              :state="errors[0] ? false : (valid ? true : null)"
              v-model="model.position"
          ></b-form-input>
        </b-form-group>
      </validation-provider>
    </div>
    <div class="row">
      <validation-provider class="col-6" vid="role_id" :name="lodash.startCase($t('users.role'))" :rules="{ required: true }" v-slot="{ valid, errors }">
        <b-form-group
            class="row mb-3 asterisk-after-text"
            label-cols-md="12"
            :label="lodash.startCase($t('users.role'))"
            label-for="role_id"
            :state="errors[0] ? false : (valid ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <b-form-select
              for="role_id"
              name="role_id"
              required
              :state="errors[0] ? false : (valid ? true : null)"
              v-model="model.role_id"
              :options="selects.roles.map((role) => ({ value: role.id, text: role.name }))"
          >
          </b-form-select>
        </b-form-group>
      </validation-provider>
      <b-form-group
          v-if="model.id"
          class="col-6 mb-3"
          label-cols-md="12"
          :label="lodash.startCase($t('users.is_active'))"
          label-for="is_active"
          label-class="pb-0"
      >
        <div class="position-relative">
          <b-form-checkbox
              id="is_active"
              :checked="!!model.is_active"
              @change="model.is_active = $event"
              switch
          >
            <status-badge
                entity="user"
                type="status"
                :status="model.is_active ? 'active' : 'inactive'"
            >
              {{ model.is_active ? lodash.startCase($t('users.active')) : lodash.startCase($t('users.inactive')) }}
            </status-badge>
          </b-form-checkbox>
          <span v-if="value && value.is_active && !model.is_active" class="inactive-warning">
            {{ $t('users.inactive_warning') }}
          </span>
        </div>
      </b-form-group>
    </div>
  </validation-observer>
</template>

<script>
  import { extend } from 'vee-validate';
  import FormModel from './model';
  import StatusBadge from "@/components/badges/status-badge.vue";

  export default {
    extends: FormModel,
    components: {
      StatusBadge,
    },
    data() {
      return {
        model: {
          email: null,
          phone: null,
          position: null,
          name: null,
          is_active: true,
          ...this.value,
          // Derive role_id from Spatie roles array; fall back to legacy role_id or default (viewer=3)
          role_id: (this.value.roles && this.value.roles.length)
            ? this.value.roles[0].id
            : (this.value.role_id || 3),
          state: {
            ...(this.value.state || {}),
            jala_trade_role: this.value.role_id === 6 ? 'admin' : ((this.value.state || {}).jala_trade_role || 'admin'),
          },
          user: {
            ...(this.value.user || {}),
          }
        },
        selects: {
          jala_trade_roles: [
            { value: '', text: '-' },
            { value: 'admin', text: this.lodash.startCase(this.$t('jala_investor_users.admin')) },
            { value: 'finance', text: this.lodash.startCase(this.$t('jala_investor_users.finance')) },
            { value: 'field_assistant', text: this.lodash.startCase(this.$t('jala_investor_users.field_assistant')) },
          ],
          roles: []
        },
        jalaUserFound: null,
        debounceFetchUserByEmail: this.lodash.debounce(this.fetchUserByEmail, 250),
        debounceFetchRoles: this.lodash.debounce(this.fetchRoles, 250)
      }
    },
    computed: {
      avatarRule() {
        if (!this.model.user.avatar || (typeof this.model.user.avatar === 'string')) return ''
        return 'image'
      }
    },
    created() {
      const vm = this;
      extend('jala_user_exists', {
        validate: (value) => !value || vm.jalaUserFound !== false,
        message: 'Email is not registered in JALA'
      });
    },
    watch: {
      'model.email'(value) {
        if (this.model.id) return;
        this.debounceFetchUserByEmail(value)
      },
    },
    methods: {
      fetchUserByEmail(value) {
        return this.$axios.get('/jala/users', {
          params: {
            all: 1,
            email__in: value || '-',
            // doesnt_have: 'investor_user',
            appends: 'avatar_url'
          }
        }).then((response) => {
          const { data: { data } } = response;
          if (data.length) {
            const jalaUser = data[0];
            this.model = {
              ...this.model,
              name: jalaUser.name,
              jala_id: jalaUser.id,
              phone: jalaUser.phone,
              user: jalaUser
            }
            this.jalaUserFound = true;
          } else {
            this.jalaUserFound = false;
            if (this.model.user.id) {
              this.model.user = {
                email: this.model.user.email
              }
            }
          }
          this.$nextTick(() => {
            if (this.$refs.emailProvider) {
              this.$refs.emailProvider.validate();
            }
          });
          return response;
        })
      },
      fetchRoles() {
        return this.$axios.get('/roles', {
          params: {
            all: 1,
            appends: 'display_name'
          }
        }).then((response) => {
          const { data: { data } } = response;
          this.selects.roles = data
          return response;
        })
      },
      validateAll() {
        const preCheck = (!this.model.id && this.model.email)
          ? this.fetchUserByEmail(this.model.email)
          : Promise.resolve();
        return preCheck.then(() => this.$refs.form.validate()).then((isValid) => {
          if (isValid) {
            const { role_id, ...modelWithoutRoleId } = this.model;
            const selectedRole = this.selects.roles.find((r) => r.id === role_id);
            this.$emit('input', {
              ...modelWithoutRoleId,
              roles: role_id ? [{ id: role_id, name: selectedRole ? selectedRole.name : undefined }] : [],
              user: {
                ...(this.model.user || {}),
                avatar: (typeof this.model.user.avatar === 'string') ? undefined : this.model.user.avatar,
                password: this.model.user.password || undefined
              },
              state: {
                ...(this.model.state || {}),
                jala_trade_role: this.model.state.jala_trade_role !== 'admin' ? this.model.state.jala_trade_role : null
              }
            })
          }
          this.$emit('update:is-valid', isValid)
          this.$emit('update:form-errors', this.$refs.form.errors)
          const field = this.lodash.find(this.$refs.form.fields, (field) => !field.passed);
          if (field) {
            const child = this.$refs.form.$children.find((child) => child.id === field.id);
            child.$el.scrollIntoView({behavior: "smooth"});
          }
          return isValid;
        }).catch(() => false);
      }
    },
    mounted() {
      this.fetchRoles()
    }
  }
</script>


<style lang="scss" scoped>
::v-deep {
  .col-form-label {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #182230;
  }

  .asterisk-after-text {
    .col-form-label::after {
      content: " *";
      color: #DC2626;
    }
  }

  .inactive-warning {
    color: #DC6803;
    font-style: italic;
    font-size: 10px;
    font-weight: 600;
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 2px;
  }
}
</style>